'use client'
import { useAuth } from '@/lib/utils/providers/supabase/supabase-auth-provider'
import { Alert, Spinner } from '@material-tailwind/react'
import { useRef, useState } from 'react'
import '../signup/style.scss'

export default function Login() {
  const { passwordReset, emailExists } = useAuth()
  const emailRef = useRef(null)
  const [loading, setLoading] = useState(false)
  const [msg, setMsg] = useState('')
  const [errorMsg, setErrorMsg] = useState('')
  const handleSubmit = async (e) => {
    e.preventDefault()
    setMsg('')
    setErrorMsg('')
    if (!emailRef.current?.value) {
      setErrorMsg('Password recovery requires an email')
      return
    }
    try {
      setLoading(true)
      console.log('passwordReset', emailRef.current.value)

      const isExists = await emailExists(emailRef.current.value)
      if (!isExists) {
        setErrorMsg(
          'The entered email does not exist in our system. Please double-check your email address.',
        )
        setLoading(false)
        return null
      }
      const { data, error } = await passwordReset(emailRef.current.value)
      console.log(error)
      console.log(data)
      if (error) {
        console.error('error11', error)
        setErrorMsg(
          error?.message || 'An error occurred while resetting password',
        )
      } else {
        setMsg('Password reset link has been sent to your email')
      }
      setLoading(false)
    } catch (e) {
      console.log(e)
    }
    setLoading(false)
  }
  return (
    <div className="flex min-h-full flex-col justify-center py-12 sm:px-6 lg:px-8 bg-gradient-to-r from-gray-900 to-black lg:pb-[460px] xl:pb-32 ">
      <div className="sm:mx-auto sm:w-full sm:max-w-md">
        <h2 className="mt-6 text-center text-3xl font-bold tracking-tight text-gray-100">
          AI Forge Reset password
        </h2>
      </div>

      <div className="mt-8 sm:mx-auto sm:w-full sm:max-w-md">
        <div className="bg-white py-8 px-4 shadow sm:rounded-lg sm:px-10">
          <form className="space-y-6">
            <div>
              <label
                htmlFor="email"
                className="block text-sm font-medium leading-6 text-gray-900"
              >
                Email address
              </label>
              <div className="mt-2">
                <input
                  id="email"
                  name="email"
                  type="email"
                  autoComplete="email"
                  required
                  ref={emailRef}
                  className="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-blue-600 sm:text-sm sm:leading-6"
                />
              </div>
            </div>
            {errorMsg && (
              <Alert
                variant="danger"
                className="buttonstyle"
                onClose={() => setErrorMsg('')}
              >
                {errorMsg}
              </Alert>
            )}
            {msg && (
              <Alert
                onClose={() => setMsg('')}
                variant="success"
                className="buttonstylesuccess"
              >
                {msg}
              </Alert>
            )}
            <div>
              <button
                type="submit"
                onClick={handleSubmit}
                disabled={loading}
                className="flex w-full justify-center gap-3 rounded-md bg-blue-600 py-2 px-3 text-sm font-semibold text-white shadow-sm hover:bg-blue-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-blue-600"
              >
                Send Reset Link
                {loading && <Spinner className="w-5 h-5 mt-1" />}
              </button>
            </div>
          </form>

          <div className="text-sm mt-4">
            <a
              href="/login"
              className="font-medium text-blue-600 hover:text-blue-500"
            >
              Back to login?
            </a>
          </div>
        </div>
      </div>
    </div>
  )
}
